<template>
  <el-dialog
    title="出票"
    :visible.sync="dialogVisible"
    width="800px"
    @close="handleClose"
  >
    <el-form
      ref="sendForm"
      :model="formData"
      :rules="rules"
      label-width="150px"
      v-loading="loading"
    >
      <el-form-item label="巴士公司订单号" prop="ticket_sn">
        <el-input v-model="formData.ticket_sn" placeholder="请输入巴士公司订单号"></el-input>
      </el-form-item>

      <el-form-item label="预留电话" prop="ticket_tel">
        <el-input v-model="formData.ticket_tel" placeholder="请输入预留电话"></el-input>
      </el-form-item>

      <el-form-item label="お支払い" prop="ticket_pay">
        <el-radio-group v-model="formData.ticket_pay">
          <el-radio label="済み">済み</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="备注" prop="ticket_note">
        <el-input
          type="textarea"
          v-model="formData.ticket_note"
          :rows="3"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>

      <el-form-item label="订票原价(日元)" prop="ticket_org_amount">
        <el-input-number
          v-model="formData.ticket_org_amount"
          :precision="2"
          :min="0"
          style="width: 100%"
        ></el-input-number>
      </el-form-item>

      <!-- 联系人信息 -->
      <div v-if="contacts.length > 0">
        <h4 style="margin: 20px 0 10px 0; color: #606266;">联系人信息</h4>
        <el-form-item
          v-for="contact in contacts"
          :key="contact.id"
          :label="`${contact.name} ${contact.sex} ${contact.age}`"
          :prop="`contact_${contact.id}`"
          :rules="contact.status === 1 ? [{ required: true, message: '请输入日文姓名', trigger: 'blur' }] : []"
        >
          <el-input
            v-if="contact.status === 1"
            v-model="formData[`contact_${contact.id}`]"
            placeholder="请输入日文姓名"
          ></el-input>
          <span v-else style="color: #909399;">已退款</span>
        </el-form-item>
      </div>

      <el-form-item label="显示为" prop="ticket_show_type">
        <el-radio-group v-model="formData.ticket_show_type">
          <el-radio :label="1">附件</el-radio>
          <el-radio :label="2">链接</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="链接" prop="ticket_link" v-if="formData.ticket_show_type === 2">
        <el-input v-model="formData.ticket_link" placeholder="请输入链接地址"></el-input>
      </el-form-item>

      <el-form-item label="附件" prop="file" v-if="formData.ticket_show_type === 1">
        <el-upload
          ref="upload"
          :action="uploadUrl"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :file-list="fileList"
          :limit="1"
          :auto-upload="true"
          name="file"
          accept=".pdf,.jpg,.jpeg,.png"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">支持PDF、JPG、PNG文件，最大20MB</div>
        </el-upload>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'OrderSendDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      submitting: false,
      contacts: [],
      fileList: [],
      uploadUrl: `${this.base_url}/upload-file`,
      formData: {
        ticket_sn: '',
        ticket_tel: '050-5327-0918',
        ticket_pay: '済み',
        ticket_note: '',
        ticket_org_amount: 0,
        ticket_show_type: 1,
        ticket_link: '',
        file: ''
      },
      rules: {
        ticket_sn: [
          { required: true, message: '请输入巴士公司订单号', trigger: 'blur' }
        ],
        ticket_tel: [
          { required: true, message: '请输入预留电话', trigger: 'blur' }
        ],
        ticket_org_amount: [
          { required: true, message: '请输入订票原价', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal && this.orderId) {
        this.loadFormData()
      }
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.$emit('update:visible', false)
      }
    }
  },
  methods: {
    async loadFormData() {
      if (!this.orderId) return
      
      this.loading = true
      try {
        const response = await axios.get(`${this.base_url}/orders/${this.orderId}/send/form`)
        if (response.status === 200 && response.data.code) {
          const data = response.data.data
          this.formData = {
            ticket_sn: data.ticket_sn || '',
            ticket_tel: data.ticket_tel || '050-5327-0918',
            ticket_pay: data.ticket_pay || '済み',
            ticket_note: data.ticket_note || '',
            ticket_org_amount: data.ticket_org_amount || 0,
            ticket_show_type: data.ticket_show_type || 1,
            ticket_link: data.ticket_link || '',
            file: data.file || ''
          }
          this.contacts = data.contacts || []
          
          // 初始化联系人字段
          this.contacts.forEach(contact => {
            if (contact.status === 1) {
              this.$set(this.formData, `contact_${contact.id}`, contact.jp_name || '')
            }
          })
        } else {
          this.$message.error(response.data.message || '获取表单数据失败')
        }
      } catch (error) {
        console.error('获取表单数据失败:', error)
        this.$message.error('获取表单数据失败')
      } finally {
        this.loading = false
      }
    },

    async handleSubmit() {
      this.$refs.sendForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            const submitData = { ...this.formData }
            
            // 添加联系人数据
            this.contacts.forEach(contact => {
              if (contact.status === 1 && this.formData[`contact_${contact.id}`]) {
                submitData[`contact_${contact.id}`] = this.formData[`contact_${contact.id}`]
              }
            })
            
            const response = await axios.post(`${this.base_url}/orders/${this.orderId}/send/submit`, submitData)
            if (response.status === 200 && response.data.code) {
              this.$message.success('出票成功')
              this.dialogVisible = false
              this.$emit('success')
            } else {
              this.$message.error(response.data.message || '出票失败')
            }
          } catch (error) {
            console.error('出票失败:', error)
            this.$message.error('出票失败')
          } finally {
            this.submitting = false
          }
        } else {
          this.$message.error('请检查表单填写是否正确')
        }
      })
    },

    handleUploadSuccess(response, file) {
      if (response && response.code) {
        this.formData.file = response.data.url
        this.$message.success('文件上传成功')
      } else {
        this.$message.error('文件上传失败')
      }
    },

    handleUploadError(error) {
      console.error('文件上传失败:', error)
      this.$message.error('文件上传失败')
    },

    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },

    resetForm() {
      this.$refs.sendForm && this.$refs.sendForm.resetFields()
      this.formData = {
        ticket_sn: '',
        ticket_tel: '050-5327-0918',
        ticket_pay: '済み',
        ticket_note: '',
        ticket_org_amount: 0,
        ticket_show_type: 1,
        ticket_link: '',
        file: ''
      }
      this.contacts = []
      this.fileList = []
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
}

.el-form {
  .el-select {
    width: 100%;
  }
}
</style>